import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getZones(planzone)
        .then((zones) => ({ planzone, zones }))
        .catch((error) => Promise.reject({ planzone, error })),
    );
}

export type { Interactor };

export { createInteractor };
